import TomSelect from "tom-select/src/tom-select.ts";
import removeButton from "tom-select/src/plugins/remove_button/plugin.ts";
import nestedSelectPlugin from "../tom-select/plugins/nested_select/plugin";

TomSelect.define("remove_button", removeButton);
TomSelect.define("nested_select_plugin", nestedSelectPlugin);

let select_options = [];

const NestedSelectHook = {
  mounted() {
    this.init(this.el);
  },
  updated() {
    const el = this.el;

    // If the options have changed, destroy the TomSelect instance and re-initialize it with the new options.
    const latestSelect = document.querySelector(`#${this.el.id}-select-latest`);
    const initialSelect = el.querySelector("select.combo-box");
    initialSelect.value = latestSelect.value;

    let latestOptions = latestSelect.querySelectorAll("option");
    let initialOptions = initialSelect.querySelectorAll("option");

    // Convert latestOptions and initialOptions to arrays
    let latestOptionsArray = Array.from(latestOptions);
    let initialOptionsArray = Array.from(initialOptions);

    // Sort the arrays by their values
    latestOptionsArray.sort((a, b) => a.value.localeCompare(b.value));
    initialOptionsArray.sort((a, b) => a.value.localeCompare(b.value));

    if (latestOptionsArray && initialOptionsArray) {
      // If the options have changed, destroy the TomSelect instance and
      // re-initialize it with the new options.
      if (latestOptionsArray.length !== initialOptionsArray.length) {
        this.refresh();
      } else {
        for (let i = 0; i < latestOptionsArray.length; i++) {
          const latestOption = latestOptionsArray[i];
          const initialOption = initialOptionsArray[i];

          if (
            latestOption.label !== initialOption.label ||
            latestOption.value !== initialOption.value
          ) {
            this.refresh();
            break;
          }
        }
      }

      for (let i = 0; i < latestOptionsArray.length; i++) {
        const latestOption = latestOptionsArray[i];
        const initialOption = initialOptionsArray[i];

        if (initialOption && latestOption.selected !== initialOption.selected) {
          initialOption.selected = latestOption.selected;
        }
      }
    }
  },
  destroyed() {
    // Hide the first div child of this.el:
    this.el.querySelector(".combo-box-wrapper").classList.add("hidden");
    this.tomSelect && this.tomSelect.destroy();
  },
  refresh() {
    this.tomSelect.refreshOptions();
  },
  async init(el) {
    const plugins = JSON.parse(el.dataset.plugins);
    const options = JSON.parse(el.dataset.options);
    const globalOpts = window[el.dataset.globalOptions];
    const selectEl = el.querySelector("select.combo-box");

    const tomSelectOptions = {
      options: select_options,
      plugins,
      ...options,
      ...globalOpts,
    };

    this.tomSelect = new TomSelect(selectEl, {
      ...tomSelectOptions,
      render: {
        option: function (data, escape) {
          if (data.is_parent) {
            return (
              '<div is_parent group="' +
              data.group +
              '">' +
              escape(data.text) +
              "</div>"
            );
          } else {
            return (
              '<div class="ml-4" group="' +
              data.group +
              '">' +
              escape(data.text) +
              "</div>"
            );
          }
        },
        optgroup_header: function (data, escape) {
          return (
            '<div class="optgroup-header !mt-0 sticky top-0 bg-white z-10">' +
            escape(data.label) +
            "</div>"
          );
        },
        item: function (data, escape) {
          if (data.is_parent) {
            return (
              '<div is_parent class="!hidden" group="' +
              data.group +
              '">' +
              "<p>" +
              escape(data.text) +
              "</p>" +
              `<span id="${data.group}-count-indicator" class="hidden">&nbsp;(${data.child_keys.length})</span>` +
              "</div>"
            );
          } else {
            return (
              '<div group="' +
              data.group +
              '">' +
              "<p>" +
              escape(data.text) +
              "</p>" +
              "</div>"
            );
          }
        },
      },
    });

    el.querySelector(".combo-box-wrapper").classList.remove("opacity-0");
  },
};

export default NestedSelectHook;
